import styled from "styled-components";
import { BbotAlert } from "top-component-library";

export const LegacyLinkAlert = styled(BbotAlert)`
  margin-bottom: 15px;
`;

export const DayField = styled.div`
  margin-bottom: 12px;

  label {
    display: block;
    font-weight: 500;
    margin-bottom: 4px;
  }

  input {
    max-width: 320px;
  }
`;

export const DayError = styled.p`
  color: #cf1322;
  margin: 4px 0 0;
`;

export const SaveRow = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 12px;
`;

export const HelpExamples = styled.div`
  color: var(--color-neutral__text-secondary);
`;

export const SettingRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 24px;
  margin-bottom: 12px;
`;

export const SettingControl = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 220px;

  label {
    font-weight: 500;
  }
`;

// A label's text and its help-tooltip icon, as two flex items rather than
// inline siblings: AntD's icon baseline otherwise sits lower than the text.
export const LabelWithTooltip = styled.span`
  display: flex;
  align-items: center;
  gap: 4px;
`;

export const TwoColumnRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 40px;
  margin-top: 12px;

  > * {
    flex: 1;
    min-width: 280px;
  }
`;

// Legends for the timeblock illustration: a "Timeblock Width" caption above
// the image, and a "Timeblock Spacing" caption rotated alongside it.
// Shrink-wrapped to the image's own rendered width so the legends stay
// pinned to it instead of drifting with the fluid column width.
export const TimeblockLegendGroup = styled.div`
  width: fit-content;
`;

export const TimeblockWidthLegend = styled.div`
  display: flex;
  justify-content: flex-end;
  font-weight: 500;
`;

export const TimeblockDiagram = styled.div`
  position: relative;
  display: flex;
`;

export const TimeblockSpacingLegend = styled.span`
  position: absolute;
  top: 80px;
  left: -75px;
  font-weight: 500;
  white-space: nowrap;
  transform: rotate(-90deg);
`;
